import type { RedcatPaymentStore } from '../RedcatPaymentProvider';

type PayButtonState = Pick<RedcatPaymentStore, 'cardReady' | 'cardValid' | 'paymentInProgress'>;

export const isPayButtonDisabled = ({
  cardReady,
  cardValid,
  paymentInProgress,
}: PayButtonState): boolean => !cardReady || !cardValid || paymentInProgress;
